import { BaseWebComponentElement } from './BaseWebComponentElement';
import { DisplayMode } from '../types/common/types';

export class BaseAdaptableWebComponent extends BaseWebComponentElement {
  set displayMode(value: DisplayMode) {
    if (!value) {
      return;
    }
    this.setAttribute('data-display-mode', value);
  }

  get displayMode(): DisplayMode {
    const value = this.getAttribute('data-display-mode');
    return value ? <DisplayMode>value : DisplayMode.DASHBOARD;
  }
}
